import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { ArrowUpRight, MapPin, HardHat } from "@phosphor-icons/react";
import AdSlot from "@/components/AdSlot";

export default function Discover() {
    const [builders, setBuilders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/builders");
                setBuilders(data);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
            <div className="text-overline text-[#E63946] mb-3">Discover</div>
            <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter leading-none uppercase mb-3">
                UK Builders
            </h1>
            <p className="max-w-xl text-neutral-600 mb-12">
                Browse galleries from active builders on the platform. Tap any card to see their work.
            </p>

            <AdSlot slot="discover_top" variant="banner" className="mb-12" />

            {loading ? (
                <div className="text-overline text-neutral-500">Loading…</div>
            ) : builders.length === 0 ? (
                <div className="border border-dashed border-neutral-400 p-16 text-center">
                    <HardHat size={36} weight="duotone" className="mx-auto mb-3" />
                    <p className="text-neutral-600">No published galleries yet. Be the first.</p>
                    <Link to="/register" className="btn-accent inline-flex mt-5">Create your gallery</Link>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {builders.map((b, i) => (
                        <Link
                            to={`/b/${b.slug}`}
                            key={b.id}
                            data-testid={`builder-card-${b.slug}`}
                            className="group card-flat fade-in-up"
                            style={{ animationDelay: `${i * 60}ms` }}
                        >
                            <div className="aspect-[4/3] overflow-hidden bg-neutral-100">
                                {b.cover_image ? (
                                    <img
                                        src={fileUrl(b.cover_image)}
                                        alt=""
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-neutral-400 text-xs uppercase tracking-widest">
                                        No cover yet
                                    </div>
                                )}
                            </div>
                            <div className="p-5 flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                    <div className="text-overline text-neutral-500 mb-1">
                                        {b.project_count} project{b.project_count !== 1 ? "s" : ""}
                                    </div>
                                    <h3 className="font-display text-xl font-bold leading-tight truncate group-hover:text-[#E63946]">
                                        {b.business_name || b.name}
                                    </h3>
                                    {b.location && (
                                        <div className="flex items-center gap-1 text-xs text-neutral-600 mt-1">
                                            <MapPin size={12} /> {b.location}
                                        </div>
                                    )}
                                </div>
                                <ArrowUpRight size={20} weight="bold" className="opacity-30 group-hover:opacity-100 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all flex-shrink-0" />
                            </div>
                        </Link>
                    ))}
                </div>
            )}

            <div className="mt-16">
                <AdSlot slot="feed" variant="card" limit={2} />
            </div>
        </div>
    );
}
